<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <Header title="The Artist" />
      <ImageGallery
        style="margin-top: 40px"
        :data="[
          require('@/assets/images/galleries/artist-kate/Kate - Slider 01.jpg'),
          require('@/assets/images/galleries/artist-kate/Kate - Slider 02.jpg'),
          require('@/assets/images/galleries/artist-kate/Kate - Slider 03.jpg'),
          require('@/assets/images/galleries/artist-kate/Kate - Slider 04.jpg'),
          require('@/assets/images/galleries/artist-kate/Kate - Slider 05.jpg'),
        ]"
        :idString="'theartist'"
      />
      <h4>KATE LYNN LEWIS</h4>
      <p>
        Kate Lynn Lewis is a Chicago-based artist focused on large-scale mural
        installations and illustrative design. Her style is best recognized by
        her clean and hard lines, bold use of color, and emphasis on both
        architectural elements and the female form. Her work can be found on the
        exteriors and interiors of municipal structures, arenas, offices,
        restaurants and residences in cities throughout the U.S.
      </p>
      <p class="italic">
        I wanted these designs to be about women, and by women. I didn’t want to
        mask our femininity or our defining features; what allows us to
        ‘peacock’ and stand out within our species to make statements.
      </p>
      <p>
        She is passionate about inspiring artists and non-artists alike to gain
        confidence in creating and references her background in math and
        business as an acknowledgement that it’s never too late to pursue a
        creative path.
      </p>

      <p>
        To learn more about Kate Lynn Lewis or to view her work, visit
        <a
          href="https://www.katelynnlewis.com"
          target="_blank"
          v-ePitchTracking="{
            site: 'kate',
            category: 'Link',
            label: 'Kate Lynn Lewis',
          }"
          >www.katelynnlewis.com.</a
        >
      </p>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
  },
};
</script>

<style lang="scss" scoped>
#the-artist {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: $md) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .italic {
    font-family: AvenirNext-Medium-Italic;
    font-size: 16px;
    color: #3e3e3e;
    text-align: center;
    line-height: 25px;
    width: 587px;
    max-width: 100%;
    &:after {
      content: url("~@/assets/images/icons/Close-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-left: 8px;
      transform: scale(0.5);
    }
    &:before {
      content: url("~@/assets/images/icons/Open-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-right: 8px;
    }
  }
  h4 {
    font-family: "Poppins-Bold";
    font-size: 20px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  p {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    line-height: 23px;
    margin-bottom: 20px;
    width: 852px;
    max-width: 100%;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
